export default "__VITE_ASSET__f5809113__"